import React, { Component } from "react";
import { Form, AutoComplete, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { apiCustomer } from "../../../../../api/api-customer";
import {
  CUSTOMER_CODE,
  CONTRACT_TYPE,
} from "../../../../../common/utils/static-data";
import { styles } from "../suggestion-styles";

const { Option } = AutoComplete;
const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;
const INFOMATION_DATA = [
  {
    id: 1,
    title: "Tên khách hàng",
    feild: "customer_info",
    type: "AutoComplete",
    options: "optionsCompany",
  },
  {
    id: 2,
    title: "Địa chỉ",
    feild: "customer_info",
    type: "Input",
    feild_chil: "address",
  },
  {
    id: 3,
    title: "User/Admin",
    feild: "user",
    type: "AutoComplete",
    options: "optionsUser",
  },
  {
    id: 4,
    title: "Số điện thoại",
    feild: "user",
    feild_chil: "phone_number",
    type: "Input",
    validation: /^-{0,1}\d*\.{0,1}\d+$/,
  },
  {
    id: 5,
    title: "Email",
    feild: "user",
    feild_chil: "email",
    type: "Input",
    validation: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  },
  {
    id: 6,
    title: "MST",
    feild: "customer_info",
    feild_chil: "tax_code",
    type: "Input",
  },
];

export class CustomerInfomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_info: {
        company_name: "",
        customer_id: -1,
        tax_code: "",
        customer_info: "",
      },
      user: {
        mobile: "",
        email: "",
      },
      optionsCompany: [],
      optionsUser: [],
      isDisableUser: true,
      isLoadMore: false,
    };

    this.timeout = null;
    this.currentValueCustomer = null;
    this.currentValueUser = null;
    this.customerTotalPage = 1;
    this.customerPage = 1;
    this.userTotalPage = 1;
    this.userPage = 1;
  }

  onSearch = (feild, data, parentField) => {
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (feild === "optionsCompany") {
      this.currentValueCustomer = data;
      this.customerPage = 1;
    } else {
      this.currentValueUser = data;
      this.userPage = 1;
    }
    if (!data) {
      if (feild === "optionsCompany") {
        this.props.onChangeForm("user", "");
        this.setState({
          [feild]: [],
          isDisableUser: true,
          user: {
            mobile: "",
            email: "",
          },
          optionsUser: [],
          customer_info: {
            company_name: "",
            customer_id: -1,
            tax_code: "",
            customer_info: "",
          },
        });
      } else {
        this.setState({
          [feild]: [],
          user: {
            mobile: "",
            email: "",
          },
        });
      }
      return;
    }
    if (feild === "optionsCompany") {
      this.props.onChangeForm("user", "");
      this.props.onChangeForm("customer_info", data.toUpperCase());
      this.setState(
        {
          isDisableUser: true,
          user: {
            mobile: "",
            email: "",
          },
          optionsUser: [],
          customer_info: {
            company_name: "",
            customer_id: -1,
            tax_code: "",
            customer_info: "",
          },
        },
        () => {
          this.props.validateFields(["user"]);
        }
      );
    } else {
      this.setState({
        user: {
          mobile: "",
          email: "",
        },
      });
    }
    async function searchData() {
      let func = apiCustomer.getCustomers;
      let filters = null;
      if (feild === "optionsCompany") {
        func = apiCustomer.customerSuggest;
        filters = { name: `%${data.trim()}%` };
      } else {
        const { customer_info } = self.state;
        func = apiCustomer.memberCustomerSuggest;
        filters = {
          customer: { id: customer_info.customer_id },
          name: `%${data.trim()}%`,
        };
      }
      try {
        const result = await func(filters, 1, 10);
        if (result.status === "success") {
          if (feild === "optionsCompany") {
            if (self.currentValueCustomer !== data) {
              return;
            }
            self.customerTotalPage = result.data.total_pages;
          } else {
            if (self.currentValueUser !== data) {
              return;
            }
            self.userTotalPage = result.data.total_pages;
          }
          const minorSearch = result.data.content.find(
            (suggestion) => suggestion.name.trim() === data.trim()
          );
          if (minorSearch) {
            const { customer_type } = minorSearch;
            return self.setState(
              {
                [parentField]: minorSearch,
                isDisableUser:
                  feild === "optionsCompany"
                    ? customer_type.code === CUSTOMER_CODE.enterprise
                      ? false
                      : true
                    : false,
                [feild]: result.data.content.map((suggestion) => {
                  const { customer_type } = suggestion;
                  return {
                    ...suggestion,
                    value:
                      feild === "optionsCompany"
                        ? `${suggestion.name} (${
                            customer_type.code === CUSTOMER_CODE.enterprise
                              ? suggestion.tax_code
                              : suggestion.phone_number
                          })`
                        : `${suggestion.name} (${suggestion.mobile})`,
                  };
                }),
              },
              () => {
                self.props.validateFields([parentField]);
              }
            );
          }
          self.setState({
            [feild]: result.data.content.map((suggestion) => {
              const { customer_type } = suggestion;
              return {
                ...suggestion,
                value:
                  feild === "optionsCompany"
                    ? `${suggestion.name} (${
                        customer_type.code === CUSTOMER_CODE.enterprise
                          ? suggestion.tax_code
                          : suggestion.phone_number
                      })`
                    : `${suggestion.name} (${suggestion.mobile})`,
              };
            }),
          });
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  onSelect = (feild, item) => {
    const { data } = item;
    if (feild === "customer_info") {
      this.props.onChangeForm("user", "");
      const { customer_type } = data;
      this.setState(
        {
          [feild]: data,
          user: {
            mobile: "",
            email: "",
          },
          isDisableUser:
            customer_type.code === CUSTOMER_CODE.enterprise ? false : true,
        },
        () => {
          this.props.validateFields(["user"]);
          this.props.onChangeForm(feild, data.name);
        }
      );
    } else {
      this.setState({ [feild]: data }, () => {
        this.props.onChangeForm(feild, data.name);
      });
    }
  };

  loadMoreFunc = async (feild) => {
    let func = apiCustomer.customerSuggest;
    let page = 1;
    let filters = {};
    if (feild === "optionsCompany") {
      func = apiCustomer.customerSuggest;
      page = this.customerPage;
      filters = { name: `%${this.currentValueCustomer.trim()}%` };
    } else {
      const { customer_info } = this.state;
      func = apiCustomer.memberCustomerSuggest;
      page = this.userPage;
      filters = {
        customer: { id: customer_info.customer_id },
        name: `%${this.currentValueUser.trim()}%`,
      };
    }
    try {
      this.setState({ isLoadMore: true });
      const result = await func(filters, page, 10);

      if (result.status === "success") {
        if (feild === "optionsCompany") {
          this.customerTotalPage = result.data.total_pages;
        } else {
          this.userTotalPage = result.data.total_pages;
        }

        this.setState(
          {
            [feild]: this.state[feild].concat(
              result.data.content.map((suggestion) => {
                const { customer_type } = suggestion;
                return {
                  ...suggestion,
                  value:
                    feild === "optionsCompany"
                      ? `${suggestion.name} (${
                          customer_type.code === CUSTOMER_CODE.enterprise
                            ? suggestion.tax_code
                            : suggestion.phone_number
                        })`
                      : `${suggestion.name} (${suggestion.mobile})`,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  suggestionRender = (data, feild) => {
    let loadMore = false;
    const IS_CUSTOMER = feild === "customer_info";
    if (IS_CUSTOMER) {
      loadMore = this.customerTotalPage > this.customerPage;
    } else {
      loadMore = this.userTotalPage > this.userPage;
    }

    const { isLoadMore } = this.state;
    return (
      <>
        {data.map((item) => {
          const { customer_type, country_code } = item;
          return (
            <Option
              data={item}
              style={styles.selectOptoption}
              key={item.value}
              value={item.value}
            >
              <div style={styles.container}>
                <div style={styles.mainTitle}>
                  {item.name}{" "}
                  {IS_CUSTOMER
                    ? `${
                        customer_type.code === CUSTOMER_CODE.enterprise
                          ? ""
                          : `- (+${country_code})${item.phone_number}`
                      }`
                    : `-(+${country_code})${item.mobile}`}
                </div>
                {IS_CUSTOMER && (
                  <div style={styles.contract_contained}>
                    {customer_type.code === CUSTOMER_CODE.enterprise
                      ? `Khách hàng doanh nghiệp`
                      : `Khách hàng cá nhân`}
                  </div>
                )}
              </div>
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                let feildLoadMore = "";
                if (IS_CUSTOMER) {
                  feildLoadMore = "optionsCompany";
                  this.customerPage++;
                } else {
                  feildLoadMore = "optionsUser";
                  this.userPage++;
                }
                this.loadMoreFunc(feildLoadMore);
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  render() {
    let email = "";
    let phone_number = "";
    const { isDisableUser, customer_info, user } = this.state;
    if (customer_info.customer_id !== -1) {
      const { customer_type } = customer_info;
      if (customer_type && customer_type.code !== CUSTOMER_CODE.enterprise) {
        email = customer_info.email;
        phone_number = customer_info.country_code
          ? "+" + customer_info.country_code + customer_info.phone_number
          : "";
      }
    }
    if (user.id !== undefined) {
      email = user.email;
      phone_number =
        user.mobile && user.country_code
          ? "+" + user.country_code + user.mobile
          : "";
    }
    const { isEdit, contract_type, isOwner, typeOption } = this.props;

    var self = this;
    return (
      <>
        <div className="title-contract">3. Thông tin khách hàng* </div>
        {INFOMATION_DATA.map((value) => {
          return (
            <Form.Item
              key={value.id}
              name={value.feild_chil ? undefined : value.feild}
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, v) {
                    const { customer_info, user } = self.state;
                    if (
                      value.feild !== "customer_info" &&
                      value.feild !== "user"
                    ) {
                      //&& value.feild !== 'user'
                      return Promise.resolve();
                    }
                    if (value.feild === "customer_info") {
                      const findIndex = self.state.optionsCompany.findIndex(
                        (item) => item.name.trim() === v.trim()
                      );
                      if (v && (v === customer_info.name || findIndex !== -1)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(`Bạn cần chọn một khách hàng!`);
                      }
                    } else {
                      if (customer_info.customer_id === -1 || isDisableUser) {
                        return Promise.resolve();
                      }
                      const { customer_type } = customer_info;

                      if (
                        customer_type &&
                        customer_type.code !== CUSTOMER_CODE.enterprise
                      ) {
                        return Promise.resolve();
                      }
                      const findIndex = self.state.optionsUser.findIndex(
                        (item) => item.name.trim() === v.trim()
                      );
                      if (v && (v === user.name || findIndex !== -1)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(`Bạn cần chọn một user!`);
                      }
                    }
                  },
                }),
              ]}
              label={`+ ${value.title}::`}
            >
              {value.type === "Input" ? (
                value.feild_chil === "email" ? (
                  <Input
                    disabled={true}
                    value={typeOption !== "create_new" && !isOwner ? "" : email}
                    placeholder={
                      typeOption !== "create_new" && !isOwner ? "" : value.title
                    }
                  />
                ) : value.feild_chil === "phone_number" ? (
                  <Input
                    disabled={true}
                    value={
                      typeOption !== "create_new" && !isOwner
                        ? ""
                        : phone_number
                    }
                    placeholder={
                      typeOption !== "create_new" && !isOwner ? "" : value.title
                    }
                  />
                ) : value.feild_chil === "address" ? (
                  <Input
                    disabled={true}
                    value={
                      typeOption !== "create_new" && !isOwner
                        ? ""
                        : this.state[value.feild][value?.feild_chil]
                    }
                    placeholder={
                      typeOption !== "create_new" && !isOwner ? "" : value.title
                    }
                  />
                ) : (
                  <Input
                    disabled={true}
                    value={this.state[value.feild][value?.feild_chil]}
                    placeholder={value.title}
                  />
                )
              ) : (
                <AutoComplete
                  getPopupContainer={(node) => {
                    if (node) {
                      return node.parentNode;
                    }
                    return document.body;
                  }}
                  ref={(ref) => (this.auto = ref)}
                  defaultActiveFirstOption={false}
                  disabled={(isDisableUser && value.id === 3) || !isEdit}
                  onSearch={(data) =>
                    this.onSearch(value?.options, data, value.feild)
                  }
                  placeholder={value.title}
                  onSelect={(data, option) =>
                    this.onSelect(value.feild, option)
                  }
                >
                  {this.suggestionRender(
                    this.state[value?.options],
                    value.feild
                  )}
                </AutoComplete>
              )}
            </Form.Item>
          );
        })}
      </>
    );
  }
}
